const Reflux = require("reflux");
const ForgottenOrganizationsActions = require("../actions/forgotten-organizations-actions");

const ForgottenOrganizationsStore = Reflux.createStore({
  state: {
    loading: true,
    failed: false,
    data: {
      forgottenOrganizations: [{
        user: {
          id: null,
          name: null
        },
        notWorked: {
          count: 0,
          percentage: 0
        },
        moreThirtyDays: {
          count: 0,
          percentage: 0
        },
        total: 0
      }]
    }
  },

  init: function() {
    this.listenTo(ForgottenOrganizationsActions.fetchData, this.onFetchStarted);
    this.listenTo(ForgottenOrganizationsActions.fetchData.completed, this.onFetchCompleted);
    this.listenTo(ForgottenOrganizationsActions.fetchData.failed, this.onFetchFailed);

    this.state = this.getInitialState();
  },

  getInitialState: function() {
    return this.state;
  },

  onFetchStarted: function() {
    this.state = {
      loading: true,
      failed: false
    };

    this.trigger(this.state);
  },

  onFetchCompleted: function(data) {
    this.state = {
      loading: false,
      data: {
        forgottenOrganizations: data.forgotten_organizations.map(item => {
          return (
            {
              user: {
                id: item.user.id,
                name: item.user.name
              },
              notWorked: {
                count: item.not_worked.count,
                percentage: item.not_worked.percentage
              },
              moreThirtyDays: {
                count: item.more_than_thirty_days.count,
                percentage: item.more_than_thirty_days.percentage
              },
              total: item.total
            }
          )
        })
      }
    }

    this.trigger(this.state);
  },

  onFetchFailed: function() {
    this.state = {
      loading: false,
      failed: true
    }

    this.trigger(this.state);
  }
});

module.exports = ForgottenOrganizationsStore;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/stores/forgotten-organizations-store.js